export default __webpack_public_path__ + "assets/_Chapters/_Images/background/Nachhaltigkeit/2.jpg";